import { Link } from 'react-router-dom';

const RefundPolicy = () => {
  return (
    <>
      <div className="policy-wrapper bg-white overflow-hidden">
         <div className="w-screen h-64 md:h-[430px] border-[3px] border-[#35A93E]">
          <img
            src="/cancel.jpeg"
            alt="Refund Banner"
            className="w-full h-full object-contain md:object-contain"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-6">
          <div className="border-b border-gray-200 pb-6 mb-10">
            <h1 className="text-2xl font-bold text-gray-900">Refund & Returns Policy</h1>
            <p className="text-base text-gray-700 mt-4">
              LifeOnPlus believes in delivering high-quality services and products. Our refund and return policies ensure fair resolution of customer grievances.
            </p>
          </div>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Eligibility for Refund</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">Refunds will be processed for failed transactions, duplicate payments, or service unavailability.</li>
              <li className="mb-2">Refunds are not applicable for digital products once accessed or consumed unless proven defective.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Process for Refund</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">Raise a refund request within 7 working days from the date of purchase.</li>
              <li className="mb-2">Email <a href="mailto:support@lifeonplus.com" className="text-blue-600 hover:underline">support@lifeonplus.com</a> with transaction ID and reason.</li>
              <li className="mb-2">Refunds will be processed to the original payment method within 7-14 business days.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Returns & Replacements (for Physical Products)</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">Return requests must be initiated within 3 days of delivery.</li>
              <li className="mb-2">Items must be unused, sealed, and in original condition.</li>
              <li className="mb-2">Refunds for returns will be initiated once the product is received and verified.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Exceptions</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">Customized or perishable items are not eligible for return.</li>
              <li className="mb-2">No refunds will be processed if fraud, misuse, or policy violations are detected.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Cancellations</h2>
            <p className="text-base text-gray-700 leading-7">
              Orders once confirmed cannot be cancelled unless service/product is not delivered within the promised time.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Contact</h2>
            <p className="text-base text-gray-700 leading-7">
              For all refund or return-related queries, contact:
            </p>
            <p className="text-base text-gray-700 leading-7 mt-3">
              Email: <a href="mailto:support@lifeonplus.com" className="text-blue-600 hover:underline">support@lifeonplus.com</a><br />
              Address: Lifeonplus Technologies India Private Limited, No.301, 3rd Floor, “Master Mind 1, Royal Palms”, Aarey Milk Colony, Goregaon (East), Mumbai-400065<br />
              Contact: 📞 <a href="tel:+919986880000" className="text-blue-600 hover:underline">99868 80000</a> | ✉️ <a href="mailto:info@lifeonplus.com" className="text-blue-600 hover:underline">info@lifeonplus.com</a>
            </p>
            <p className="text-base text-gray-700 leading-7 mt-3">
              Disputes will be resolved as per LifeOnPlus <Link to="/grievance-redressal" className="text-blue-600 hover:underline">grievance redressal policy</Link>.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;